<template>
  <v-hover v-slot="{ hover }">
    <v-card
      class="notification-card"
      :class="{ 'on-hover': hover }"
      :elevation="hover ? 2 : 0"
      outlined
      @click="$emit('open')"
    >
      <v-list-item three-line :class="module.borderClass">
        <v-avatar
          class="notification-avatar"
          :color="module.avatarColor"
          size="60"
        >
          <span class="notification-avatar__text">{{ module.avatarText }}</span>
        </v-avatar>

        <v-list-item-content>
          <v-list-item-title class="subtitle mb-3">
            <span>{{ title }}</span>
          </v-list-item-title>
          <v-list-item-subtitle class="mb-2 notification-subtitle">
            {{ subtitle }}
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="d-flex justify-space-between align-center"
          >
            <span
              class="notification-status-chip"
              :style="{ color: statusColor }"
            >
              Status: {{ statusLabel }}
            </span>
            <span class="notification-date">{{ formattedDate }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <div
        v-if="ribbon"
        class="notification-ribbon"
        :style="{ background: ribbon.color }"
      >
        <p>{{ ribbon.text }}</p>
      </div>
      <div v-if="mod.key == 'notification'"
        :style="`position:absolute; top:0; right:-18px; width:100px; height:15px; background:${
          item.status === 1 ? '#679e98;' : 'red'
        }; transform:`"
      >
        <p
          style="
            margin: 0;
            padding: 0;
            font-size: 10px;
            text-align: center;
            font-weight: 600;
            color: white;
          "
        >
          {{ item.status === 0 ? 'Belum Dibaca' : 'Sudah Dibaca' }}
        </p>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'NotificationCard',
  props: {
    // Data mentah item notifikasi (dari salah satu getter Vuex).
    item: {
      type: Object,
      required: true
    },
    // Salah satu entri dari NOTIFICATION_MODULES — menentukan warna
    // avatar, border kiri, dan teks avatar (IZN/CTI/FPB/dst).
    module: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: '-'
    },
    subtitle: {
      type: [String, Number],
      default: '-'
    },
    statusLabel: {
      type: String,
      default: '-'
    },
    statusColor: {
      type: String,
      default: 'black'
    },
    // { color, text } — hanya diisi untuk modul yang punya pita status
    // di pojok kanan atas (saat ini: Izin & Cuti). Modul lain null.
    ribbon: {
      type: Object,
      default: null
    },
    mod: {
      type: Object,
      default: null
    }
  },
  computed: {
    formattedDate() {
      if (!this.item.created_at) return ''
      return this.item.created_at
      // const idx = this.item.created_at.lastIndexOf(' ')
      // return idx > -1
      //   ? this.item.created_at.slice(0, idx)
      //   : this.item.created_at
    }
  }
}
</script>

<style scoped>
.notification-card {
  margin-top: 15px;
  border-radius: 15px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.notification-card.on-hover {
  background-color: rgba(255, 255, 255, 0.8);
}

.notification-avatar {
  margin-right: 10px;
  border: 2px solid #3d3d3d;
  box-shadow: 0 4px 10px rgba(108, 92, 231, 0.3),
    0 0 20px rgba(108, 92, 231, 0.2);
}

.notification-avatar__text {
  font-weight: bold;
  color: #fff;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  transform: rotate(-15deg);
}

.notification-subtitle {
  font-weight: bold;
}

.notification-status-chip {
  background-color: rgb(243, 255, 173);
  padding: 8px 10px;
  border-radius: 5px;
  margin-right: 10px;
  font-size: 12px;
}

.notification-date {
  margin-left: auto;
  font-size: 11px;
  color: black;
}

.notification-ribbon {
  position: absolute;
  top: 18px;
  right: -18px;
  width: 100px;
  height: 15px;
  transform: rotate(40deg);
}

.notification-ribbon p {
  margin: 0;
  padding: 0;
  font-size: 10px;
  text-align: center;
  font-weight: 600;
  color: white;
}

/* Class ini datang dari module.borderClass (lihat notificationModules.js) */
.yellow-background {
  border-left: 5px solid rgb(218, 218, 102);
  padding-left: 15px;
}

.blue-background {
  border-left: 5px solid rgb(94, 94, 213);
  padding-left: 15px;
}

.green-background {
  border-left: 5px solid rgb(60, 194, 132);
  padding-left: 15px;
}

.card-read {
  color: rgba(0, 0, 0, 0.5);
  font-weight: 40;
}
.card-unread {
  background-color: #e5e4e2;
  font-weight: 600;
}
</style>
